import {
    EyeOutlined,
    EyeInvisibleOutlined,
    DownOutlined,
    SettingOutlined,
} from '@ant-design/icons';
import { useFilter } from '../AssetManagerContext';
import { useState } from 'react';
import { Button, Dropdown } from 'antd';

export function ColumnVisibilityMenu() {
    const { setVisibleCols, tempCols, setTempCols } = useFilter();
    const [open, setOpen] = useState(false);

    const toggleTempCol = (col) => {
        setTempCols((prev) => ({ ...prev, [col]: !prev[col] }));
    };

    const applyChanges = () => {
        setVisibleCols(tempCols);
        setOpen(false); // close dropdown on apply
    };

    const resetAll = () => {
        const allVisible = Object.keys(tempCols).reduce(
            (acc, key) => ({ ...acc, [key]: true }),
            {}
        );
        setTempCols(allVisible);
        setVisibleCols(allVisible);
    };

    const overlayContent = (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: 220,
                maxHeight: 300,
                background: 'white',
                border: '1px solid #f0f0f0',
                borderRadius: 4,
            }}
            onClick={(e) => e.stopPropagation()}
        >
            {/* Scrollable list */}
            <div
                style={{
                    flex: 1,
                    overflowY: 'auto',
                    padding: '4px 0',
                }}
            >
                {Object.entries(tempCols).map(([col, visible]) => (
                    <div
                        key={col}
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '4px 8px',
                            cursor: 'pointer',
                            textTransform: 'capitalize',
                        }}
                        onClick={() => toggleTempCol(col)}
                    >
                        <span style={{ color: visible ? 'black' : '#aaa' }}>
                            {col}
                        </span>
                        {visible ? (
                            <EyeOutlined style={{ color: 'black' }} />
                        ) : (
                            <EyeInvisibleOutlined style={{ color: '#aaa' }} />
                        )}
                    </div>
                ))}
            </div>

            {/* Footer buttons always visible */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '8px',
                    borderTop: '1px solid #f0f0f0',
                    background: 'white', // ensure background covers scroll shadow
                    zIndex: 1,
                }}
            >
                <Button size="small" onClick={resetAll}>
                    Show All
                </Button>
                <Button size="small" type="primary" onClick={applyChanges}>
                    Apply
                </Button>
            </div>
        </div>
    );

    return (
        <Dropdown
            dropdownRender={() => overlayContent}
            trigger={['click']}
            open={open}
            onOpenChange={setOpen}
            placement="bottomLeft"
        >
            <Button icon={<SettingOutlined />}>
                Columns <DownOutlined />
            </Button>
        </Dropdown>
    );
}
